const queryOptions = (t) => [
  {
    name: 'id',
    displayName: t('queryBuilder.queryParam.queryOptions.printer.id'),
    type: 'string',
    used: false,
    value: ''
  },
  {
    name: 'orderId',
    displayName: t('queryBuilder.queryParam.queryOptions.printer.orderId'),
    type: 'string',
    used: false,
    value: ''
  },
  {
    name: 'shopId',
    displayName: t('queryBuilder.queryParam.queryOptions.printer.shopId'),
    type: 'string',
    used: false,
    value: ''
  },
  {
    name: 'deliveryTarget',
    displayName: t('queryBuilder.queryParam.queryOptions.printer.deliveryTarget'),
    type: 'string',
    // This will be needed if the delivery target editor is fixed
    // type: "deliveryTarget",
    used: false,
    value: ''
  },
  {
    name: 'deliveryType',
    displayName: t('queryBuilder.queryParam.queryOptions.printer.deliveryType'),
    type: 'select',
    values: ['EMAIL', 'POST'],
    displayedValues: [
      t('queryBuilder.queryParam.queryOptions.printer.deliveryTypeValues.EMAIL'),
      t('queryBuilder.queryParam.queryOptions.printer.deliveryTypeValues.POST')
    ],
    used: false,
    value: ''
  },
  {
    name: 'createdAt',
    displayName: t('queryBuilder.queryParam.queryOptions.printer.createdAt'),
    type: 'date',
    used: false,
    value: ''
  },
  {
    name: 'expiration',
    displayName: t('queryBuilder.queryParam.queryOptions.printer.expiration'),
    type: 'date',
    used: false,
    value: ''
  },
  {
    name: 'status',
    displayName: t('queryBuilder.queryParam.queryOptions.printer.status'),
    type: 'select',
    values: ['PENDING', 'SHIPPED', 'SHIPPING_READY', 'SHIPPING', 'REJECTED'],
    displayedValues: [
      t('queryBuilder.queryParam.queryOptions.printer.statusValues.PENDING'),
      t('queryBuilder.queryParam.queryOptions.printer.statusValues.SHIPPED'),
      t('queryBuilder.queryParam.queryOptions.printer.statusValues.SHIPPING_READY'),
      t('queryBuilder.queryParam.queryOptions.printer.statusValues.SHIPPING'),
      t('queryBuilder.queryParam.queryOptions.printer.statusValues.REJECTED')
    ],
    used: false,
    value: ''
  },
  {
    name: 'sort',
    displayName: t('queryBuilder.queryParam.queryOptions.printer.sort.title'),
    type: 'key-value',
    keys: [
      { name: 'id', displayName: t('queryBuilder.queryParam.queryOptions.printer.sort.keys.id') },
      { name: 'shopId', displayName: t('queryBuilder.queryParam.queryOptions.printer.sort.keys.shopId') },
      { name: 'orderId', displayName: t('queryBuilder.queryParam.queryOptions.printer.sort.keys.orderId') },
      { name: 'customerName', displayName: t('queryBuilder.queryParam.queryOptions.printer.sort.keys.customerName') },
      { name: 'status', displayName: t('queryBuilder.queryParam.queryOptions.printer.sort.keys.status') },
      {
        name: 'deliveryTarget',
        displayName: t('queryBuilder.queryParam.queryOptions.printer.sort.keys.deliveryTarget')
      }
    ],
    values: [
      { name: 'asc', displayName: t('queryBuilder.queryParam.queryOptions.printer.sort.values.asc') },
      { name: 'desc', displayName: t('queryBuilder.queryParam.queryOptions.printer.sort.values.desc') }
    ],
    used: false,
    value: ''
  },
  {
    name: 'pagination',
    displayName: '',
    type: 'pagination',
    used: true,
    value: ''
  }
];

export default queryOptions;
